import moment from 'moment'

/**
 * 현재 시간이랑 작성 시간 비교 함수
 * @param createdDate 작성 시간
 * @returns 현재 시간이랑 작성 시간 차이
 */
export const diffHours = (createdDate: string) => {
  const currentDate = moment(new Date()) // 현재 시간
  const diffHours = moment.duration(currentDate.diff(createdDate)).asHours() // 시간 차이 계산
  return diffHours
}
